import { render, staticRenderFns } from "./MessageInsert.vue?vue&type=template&id=1ca7f371&scoped=true&"
import script from "./MessageInsert.vue?vue&type=script&lang=js&"
export * from "./MessageInsert.vue?vue&type=script&lang=js&"
import style0 from "./MessageInsert.vue?vue&type=style&index=0&id=1ca7f371&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7f371",
  null
  
)

export default component.exports